import { Component, effect, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

import { PublicKey } from '@solana/web3.js';
import { PresaleDataService } from '../../services/connection-services/data.service';
import { PopupService } from '../../services/popup.service';

@Component({
    selector: 'app-refer',
    templateUrl: './refer.component.html',
    styleUrls: ['./refer.component.scss'],
    standalone: false
})
export class ReferComponent {
  walletAddress: string = '';
  originalUrl: string = '';

  readonly modalRef = inject(BsModalRef);
  private readonly popupService = inject(PopupService);
  private readonly translateService = inject(TranslateService);
  private readonly dataService = inject(PresaleDataService);
  public evmWalletAddress!:string;
  public solWalletAddress!:string;

  constructor() {
     effect(() => {
      this.dataService.walletAddressSignal();
      this.evmWalletAddress = this.dataService.walletAddress;
      this.solWalletAddress = this.dataService.walletAddressSOL;
    });
  }


  /**
   * Validates if an address is a valid EVM address (0x followed by 40 hex characters)
   */
  private isValidEvmAddress(address: string): boolean {
    const evmAddressRegex = /^0x[a-fA-F0-9]{40}$/;
    return evmAddressRegex.test(address);
  }

  /**
   * Validates if an address is a valid Solana address (base58 string, 44-45 characters)
   */
  private isValidSolAddress(address: any): boolean {
    try {
      const publicAddress = new PublicKey(address);
      return PublicKey.isOnCurve(publicAddress.toBytes());
    } catch (error) {
      return false;
    }
    // const solAddressRegex = /^[1-9A-HJ-NP-Za-km-z]{32,44}$/;
    // return solAddressRegex.test(address);
  }

  /**
   * Submits the referral addresses with validation
   */
  submitAddresses(): void {
    // Validate EVM Address
    if (!this.evmWalletAddress || this.evmWalletAddress.trim() === '') {
      this.popupService.messsageAlert('error', 'EVM address is required');
      return;
    }

    if (!this.isValidEvmAddress(this.evmWalletAddress.trim())) {
      this.popupService.messsageAlert('error', 'Invalid EVM address format');
      return;
    }

    // Validate SOL Address
    if (!this.solWalletAddress || this.solWalletAddress.trim() === '') {
      this.popupService.messsageAlert('error', 'SOL address is required');
      return;
    }

    if (!this.isValidSolAddress(this.solWalletAddress.trim())) {
      this.popupService.messsageAlert('error', 'Invalid SOL address format');
      return;
    }

    // Log the values if validation passes
    console.log('EVM Address:', this.evmWalletAddress);
    console.log('SOL Address:', this.solWalletAddress);
    const url = window.location.origin + "?refAddressEvm=" + this.evmWalletAddress + "&refAddressSol=" + this.solWalletAddress;
    navigator.clipboard.writeText(url)
    this.copy();
    setTimeout(() => {
      this.modalRef?.hide()
    }, 500);
  }

  copy() {
    this.popupService.messsageAlert('success', this.translateService.instant('misc.successCopy'));
  }
}
